import React from 'react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import { Wordmark } from '../lib/ui';

const GoogleG = () => (
  <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5h-1.9V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8a12 12 0 1 1 0-24c3 0 5.8 1.1 7.9 3l5.7-5.7A20 20 0 1 0 24 44c11 0 20-8.9 20-20 0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8A12 12 0 0 1 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7A20 20 0 0 0 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2A12 12 0 0 1 12.7 28l-6.6 5.1A20 20 0 0 0 24 44z"/><path fill="#1976D2" d="M43.6 20.5H24v8h11.3a12 12 0 0 1-4.1 5.6l6.2 5.2C41.4 36 44 30.6 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
);

export default function LoginSheet({ reason, onClose, onLogin }) {
  return (
    <div data-testid="modal-login-prompt" onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,18,16,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 2000 }}>
      <div onClick={e => e.stopPropagation()} className="ps-fade-up" style={{ width: '100%', maxWidth: 460, background: PS.surface2, borderRadius: '24px 24px 0 0', padding: '22px 22px max(22px, env(safe-area-inset-bottom))', fontFamily: PS.fontUI }}>
        <div style={{ width: 40, height: 4, borderRadius: 2, background: PS.line, margin: '0 auto 18px' }} />
        <Wordmark size={20} />
        <div style={{ fontSize: 19, fontWeight: 700, letterSpacing: -0.3, marginTop: 14 }}>เข้าสู่ระบบเพื่อดำเนินการต่อ</div>
        <div style={{ fontSize: 13, color: PS.textMuted, marginTop: 6, lineHeight: 1.5 }}>{reason || 'ฟีเจอร์นี้ต้องเข้าสู่ระบบก่อน'} — ศึกษาข้อมูลและดูวงต่างๆ ได้ฟรีโดยไม่ต้องสมัคร</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 18 }}>
          {[['shield', 'เราไม่ถือเงินของคุณ — เป็นเพียงผู้เก็บหลักฐาน'], ['lock', 'ทุกอย่างถูกบันทึกด้วย SHA-256 แก้ไขไม่ได้']].map(([ic, t], i) => {
            const IcoC = Icon[ic];
            return (
              <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 12.5, color: PS.text }}>
                <div style={{ width: 28, height: 28, borderRadius: 9, background: 'oklch(0.78 0.06 155 / 0.28)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><IcoC size={15} stroke="oklch(0.38 0.08 155)" /></div>
                {t}
              </div>
            );
          })}
        </div>

        <button data-testid="login-sheet-google-btn" onClick={onLogin} className="ps-press" style={{ width: '100%', height: 52, marginTop: 20, background: PS.ink, color: PS.page, border: 'none', borderRadius: 14, fontSize: 15, fontWeight: 600, fontFamily: PS.fontUI, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
          <span style={{ background: '#fff', borderRadius: 4, padding: 3, display: 'flex' }}><GoogleG /></span>
          เข้าสู่ระบบด้วย Google
        </button>
        <button data-testid="login-sheet-close-btn" onClick={onClose} className="ps-press" style={{ width: '100%', height: 44, marginTop: 8, background: 'transparent', color: PS.textMuted, border: 'none', fontSize: 13, fontWeight: 500, fontFamily: PS.fontUI }}>
          ดูต่อแบบผู้เยี่ยมชม
        </button>
      </div>
    </div>
  );
}
